export default "__VITE_ASSET__BNL85UGb__"